import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {RequestApiService} from "../../../../services/api/request/request-api.service";

@Component({
  selector: 'app-request-nexa',
  templateUrl: './request-nexa.component.html',
  styleUrl: './request-nexa.component.css'
})
export class RequestNexaComponent implements OnInit, OnDestroy  {

  @Input() requestDetails;
  @Output() isPinned = new EventEmitter<boolean>();
  
  public ticketSummary: any;
  public ticketError: any = null;
  public panels: any = [];
  public loading = false;
  public pinned = false;
  public tabs: any = [];
  public activeTab = false;
  private localStorageKey = 'ticketSummary';
  public toolName = '';
  public nexaSave = false;
  public aiToolEnabled = false;
  public activateSave = true;
  public activatePin = true;

  constructor(private toastr: ToastrService,
    private requestApi: RequestApiService
  ) { }

  ngOnInit(): void {
    this.getPinned();
    this.getToolName();
    this.IsAIToolEnabled();

    const storedTicketSummary = localStorage.getItem(this.localStorageKey + this.requestDetails.Id);
    if (this.activateSave) {
      if (storedTicketSummary) {
        this.ticketSummary = JSON.parse(storedTicketSummary);
        this.nexaSave = true;
        this.createPanels();
        this.createTabs();    
      } else {
        this.nexaSave = false;
        this.refreshCheckNEXAAI();
      }
    } else {
      this.refreshCheckNEXAAI();
    }
  }

  public toggleNexaSave() {
    if (this.ticketError == null) {
      if (this.nexaSave) {
        this.nexaSave = false;
        localStorage.removeItem(this.localStorageKey + this.requestDetails.Id);
      } else {
        this.nexaSave = true;
          // save on local storage
          localStorage.setItem(this.localStorageKey + this.requestDetails.Id, JSON.stringify(this.ticketSummary));
      }
    } else {
      this.toastr.warning('Cannot bookmark empty Summary', 'Warn');
    }
  }

  private getToolName(){
    this.requestApi.getAiToolName().then(response => {
      this.toolName = response.AIToolName;
      console.log('toolname = ', this.toolName);
    })
  }

  private IsAIToolEnabled(){
    this.requestApi.istAiToolEnabled().then(response => {
      this.aiToolEnabled = response.IsAIToolEnabled;
    })
  }

  public createTabs() {
    this.tabs = [
      { id: 1, title: 'Summary', content: 'This is the content for Tab 1.',
        requester: this.ticketSummary.requester.name,
        issue: this.ticketSummary.request.issue,
        priority: this.ticketSummary.request.priority,
        description: this.ticketSummary.request.description,
        reply: this.ticketSummary.request.reply
       },
      { id: 2, title: 'Knowledge', content: 'This is the content for Tab 2.' }
    ];
  
    // Initially, the first tab is active.
    this.activeTab = this.tabs[0];
  
  }

    // Method to change the active tab.
    public selectTab(tab: any): void {
      this.activeTab = tab;
    }

  public createPanels() {
    this.panels = [
      {
        id: 1,
        title: 'Understanding this ticket',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
        requester: this.ticketSummary.requester.name,
        issue: this.ticketSummary.request.issue,
        priority: this.ticketSummary.request.priority,
        description: this.ticketSummary.request.description,
        reply: this.ticketSummary.request.reply,
        active: true
      },
      {
        id: 2,
        title: 'Suggensted Next Steps',
        content: this.ticketSummary.suggestedNextSteps,
        active: true
      },
      {
        id: 3,
        title: 'SuggesTed Response',
        content: this.ticketSummary.suggestedResponse,
        active: true
      }
    ];
  }

  getPinned(){
    let pinned = localStorage.getItem('pinned');
    if (pinned == null) {
      localStorage.setItem('pinned', 'false')
    } else {
      this.pinned = JSON.parse(pinned);
    }
  }

  public togglePIN() {
    let pinned = localStorage.getItem('pinned');
    if (pinned == null) {
      localStorage.setItem('pinned', 'true');
      this.pinned = true;
      this.toastr.success('NEXA successfullt pinned');
    } else {
      this.pinned = JSON.parse(pinned);

      this.pinned = !this.pinned;
      localStorage.setItem('pinned', String(this.pinned));
      console.log('aSAVING TO LOCALS STORAGE B');

      if (this.pinned) {
        this.toastr.success('NEXA successfullt pinned');
      } else {
        this.toastr.success('NEXA successfullt unpinned');
      }
    }
    this.isPinned.emit(this.pinned);    
  }

  public refreshCheckNEXAAI() {
    this.getNexaAIData();
  }

  private getNexaAIData() {
    this.loading = true;
    this.ticketError = null;

    // let id = '122232';
    // let id = '722607';
    let id = this.requestDetails.Id;

    this.requestApi.getAiToolSummary(id).then(response => {
      this.loading = false;
      if (response.success == true) {
        this.ticketSummary = response.data;

        // remove the bookmark
        this.nexaSave = false;
        localStorage.removeItem(this.localStorageKey + this.requestDetails.Id);
  
        this.createPanels();
        this.createTabs();    
      } else {
        this.ticketError = response;

        if (this.ticketError && this.ticketError.details && this.ticketError.details.exception) {
          this.toastr.error(this.ticketError.details.exception, 'Error');
        } else if (this.ticketError && this.ticketError.details && this.ticketError.details.error) {
          this.toastr.error(this.ticketError.details.error, 'Error');
        } else if (this.ticketError.error) {
          this.toastr.error(this.ticketError.error, 'Error');
        } else {
          this.toastr.error('An error occured', 'Error');
        }
        console.error('ticketError = :', this.ticketError);
      }
    })
    .catch(error => {
      this.loading = false;
      // Handle connection or unexpected server errors
      this.ticketError = {
        success: false,
        error: 'An error occurred while fetching data.',
        details: error
      };
      this.toastr.error(this.ticketError.error, 'Error');
      console.error('API call failed:', error);
    });

    // setTimeout(() => {

    //   this.ticketSummary = {
    //     "request": {
    //       "id": 189029,  
    //       "localId": 25,
    //       "requestTypeId":200,
    //       "requestType":"Incident",
    //       "requestStatusId":546,
    //       "requestStatus":"Open", 
    //       "priorityId":591,
    //       "priority": "High",
    //       "issue": "Email not syncing with Microsoft Outlook",
    //       "description": "Client cannot access important emails; restarting and re-entering credentials did not resolve the issue."
    //     },
    //     "requester": {
    //       "name": "Jane Doe",
    //       "department": "Sales Department"
    //     },
    //     "suggestedNextSteps": [
    //       {
    //         "step": 1,
    //         "title": "Check email server status",
    //         "details": "Verify if there are any ongoing issues with the company's email server (e.g., Exchange server)."
    //       },
    //       {
    //         "step": 2,
    //         "title": "Guide client to clear cache and re-enter credentials",
    //         "details": "Provide steps for clearing cache in Outlook. Ask the client to re-enter their credentials after clearing cache."
    //       },
    //       {
    //         "step": 3,
    //         "title": "Run diagnostic script remotely",
    //         "details": "Initiate a remote diagnostic tool to check connectivity between the client’s device and the email server."
    //       },
    //       {
    //         "step": 4,
    //         "title": "Escalation Option",
    //         "details": "If the sync issue persists after diagnostics, escalate to the infrastructure team."
    //       }
    //     ],
    //     "suggestedResponse": "Hello Jane, thank you for reaching out. We understand this is urgent. Here's what we suggest as the next steps:\n\n1. Clear Outlook cache:\n  - Close Microsoft Outlook.\n  - Navigate to the Outlook settings > Account settings > Clear Cache.\n  - Restart Outlook and re-enter your login credentials.\n\n2. Check your network connection:\n  - Ensure you are connected to a stable network.\n\nIf the issue persists, let us know, and we will initiate a remote diagnostic check on your device. We’ll work to resolve this as soon as possible. Thank you for your patience."
    //   };
  
    //   this.loading = false;

    //   // remove the bookmark
    //   this.nexaSave = false;
    //   localStorage.removeItem(this.localStorageKey + this.requestDetails.Id);

    //   this.createPanels();
    //   this.createTabs();    
    // }, 2000);    
  };    


  // Toggle the panel's open/close state
  togglePanel(panel: any): void {
    panel.active = !panel.active;
  }

  ngOnDestroy(): void {
  }

}
